export default __webpack_public_path__ + "static/media/facebook.c8dbfb05.svg";